import { MutationTree } from 'vuex';
import { State } from './state';
import { HistoryMutationTypes } from './mutation-types';
import { HistoryItemResponse, HistoryListResponseItem } from './types';
import { find } from 'lodash';

export type Mutations<S = State> = {
  [HistoryMutationTypes.SET_PORTFOLIO_HISTORY](
    state: S,
    payload: Array<HistoryItemResponse>
  ): void;
  [HistoryMutationTypes.SET_HISTORY_LIST](
    state: S,
    payload: {
      id: string;
      data: Array<HistoryListResponseItem>;
    }
  ): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [HistoryMutationTypes.SET_PORTFOLIO_HISTORY](
    state: State,
    payload: Array<HistoryItemResponse>
  ) {
    state.history = payload;
  },
  [HistoryMutationTypes.SET_HISTORY_LIST](
    state: State,
    payload: {
      id: string;
      data: Array<HistoryListResponseItem>;
    }
  ) {
    if (state.historyList && state.historyList.length > 0 && payload) {
      const foundItem = find(state.historyList, x => x.id === payload.id);
      if (foundItem) {
        foundItem.data = payload.data;
      } else {
        state.historyList.push(payload);
      }
    } else {
      state.historyList = payload ? [payload] : [];
    }
  },
};
